export const COSMIC_BUCKET_SLUG =
  process.env.VUE_APP_COSMIC_BUCKET_SLUG || 'tulumparty-cabo';
export const COSMIC_READ_KEY =
  process.env.VUE_APP_COSMIC_READ_KEY ||
  'YDn0yNZsHaT54IO4Uk6q4uVeiWxu0yzonz0lUo1eK91g4W8j0F';
export const COSMIC_BASE_URL = `https://api.cosmicjs.com/v3/buckets/${COSMIC_BUCKET_SLUG}/objects?read_key=${COSMIC_READ_KEY}`;
export const MEDIA_BASE_URL = `https://api.cosmicjs.com/v3/buckets/${COSMIC_BUCKET_SLUG}/media`;
export const AUTODJSCHDULES = 'autodjschedules';
const LIMIT = 16;
export const PARTY_LIMIT = 25;
const FAQ_LIMIT = 40;
const FAQ_CLUB_LIMIT = 3;
const ALL_PARTY_LIMIT = 55;
const DJ_SCHEDULE = 150;
let ONE_DAY = 86400000;
let SIX_HOURS = ONE_DAY / 4;
let PARTY_START_RANGE = new Date(Date.now() - ONE_DAY)
  .toISOString()
  .slice(0, 10);

let SCHEDULE_START_RANGE = new Date(Date.now() - SIX_HOURS)
  .toISOString()
  .slice(0, 10);

let metadataFieldsParty = [
  'metadata.extra_content',
  'metadata.caption',
  'metadata.video.content',
  'metadata.video.metadata',
  'metadata.date',
  'metadata.start_time',
  'metadata.tickets_link',
  'metadata.reservations_link',
  'metadata.google_calendar_link',
  'metadata.lineup',
  'metadata.primary_color',
  'metadata.secondary_color',
  'metadata.event_link',
  'metadata.main_image',
  'metadata.club.title',
  'metadata.club.metadata.address',
  'metadata.club.slug',
  'metadata.venue.title',
  'metadata.venue.metadata.address',
  'metadata.venue.slug',
  'metadata.brand.id',
  'metadata.brand.slug',
  'metadata.brand.title',
  'metadata.brand.metadata.description',
  'metadata.brand.metadata.logo',
  'metadata.brand.metadata.main_image',
  // Event Layout relation
  'metadata.event_layout.slug',
  'metadata.event_layout.title',
  'metadata.event_layout.metadata.content',
  'metadata.event_layout.metadata.main_image.imgix_url',
  'metadata.event_layout.metadata.media_folder',
  'metadata.event_layout.metadata.sections',
  'metadata.event_layout.metadata.valid_for',
  'metadata.event_layout.metadata.notes',
  'metadata.event_layout.metadata.primary_color',
  'metadata.event_layout.metadata.secondary_color',
  'metadata.event_layout.metadata.reservations_link',
].join(',');
let metadataFieldsParties = [
  'metadata.extra_content',
  'metadata.caption',
  'metadata.video.content',
  'metadata.video.metadata',
  'metadata.date',
  // 'metadata.brand.title',
  // 'metadata.brand.slug',
  'metadata.tickets_link',
  'metadata.reservations_link',
  'metadata.lineup',
  'metadata.start_time',
  'metadata.main_image',
  // 'metadata.venue.title',
  // 'metadata.venue.metadata.address',
  // 'metadata.venue.slug'
].join(',');
let metadataFieldsPartiesIndex = [
  'metadata.extra_content',
  'metadata.caption',
  // 'metadata.video.content',
  // 'metadata.video.metadata',
  'metadata.date',
  // 'metadata.brand.title',
  // 'metadata.brand.slug',
  'metadata.tickets_link',
  'metadata.reservations_link',
  'metadata.lineup',
  'metadata.start_time',
  'metadata.main_image',
  // 'metadata.venue.title',
  // 'metadata.venue.metadata.address',
  // 'metadata.venue.slug'
].join(',');
let metadataFieldsAllParty = [
  'metadata.caption',
  'metadata.main_image',
  'metadata.date',
  'metadata.lineup',
  'metadata.start_time',
].join(',');
let metadataFieldsArtist = [
  'metadata.genre',
  'metadata.content',

  'metadata.headline',
  'metadata.spotify_listeners',
  'metadata.spotify_id',
  'metadata.videoid',
  'metadata.videotitle',
  'metadata.videocaption',
  'metadata.main_image',
  'metadata.soundcloud',
  'metadata.short',
  'metadata.flag',
  'metadata.parties.slug',
  'metadata.parties.title',
  'metadata.parties.metadata.main_image',
  'metadata.parties.metadata.start_time',
  'metadata.parties.metadata.venue.slug',
  'metadata.parties.metadata.venue.title',
  'metadata.parties.metadata.date',
  'metadata.instagram',
  'metadata.headline',
].join(',');
let metadataFieldsFestival = [
  'metadata.parties.slug',
  'metadata.parties.title',
  // 'metadata.parties.metadata.brand.title',
  // 'metadata.parties.metadata.brand.slug',
  'metadata.parties.metadata.main_image',
  'metadata.parties.metadata.lineup',
  'metadata.parties.metadata.start_time',
  // 'metadata.parties.metadata.venue.slug',
  // 'metadata.parties.metadata.venue.title',
  'metadata.parties.metadata.date',
].join(',');
let metadataFieldsBrand = [
  'metadata.main_image',
  'metadata.logo',
  'metadata.instagram_profile',
  'metadata.past_parties.slug',
  'metadata.past_parties.title',
  'metadata.past_parties.metadata.main_image',
  'metadata.past_parties.metadata.lineup',
  'metadata.past_parties.metadata.start_time',
  'metadata.past_parties.metadata.venue.slug',
  'metadata.past_parties.metadata.venue.title',
  'metadata.past_parties.metadata.date',
].join(',');
let metadataFieldsBrandIndex = [
  'metadata.main_image',
  'metadata.description',
  'metadata.logo',
].join(',');

const getParty = (slug) => {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&props=title,slug,content,${metadataFieldsParty}&query={"type":"san-jose-cabo-party","slug":"${slug}"}`
    )
  ).then((response) => response.json());
};

const MINI_PARTIES_LIMIT = 165;

function getMiniParties(args, type = 'miniparties') {
  let request = `${COSMIC_BASE_URL}&limit=${MINI_PARTIES_LIMIT}&sort=metadata.date&props=id,title,slug,content,metadata&query={
      "type":"${type}",
      "metadata.date": {"$gte": "${PARTY_START_RANGE}"}`;
  if (args) {
    request += `,"slug": { "$regex": "${args}", "$options": "i"}}`;
    return fetch(encodeURI(request)).then((response) => response.json());
  } else {
    return fetch(encodeURI(request + '}')).then((response) => response.json());
  }
}

function getPromotedMiniParties() {
  let request = `${COSMIC_BASE_URL}&limit=25&sort=metadata.date&props=id,title,slug,content,metadata&query={"type":"miniparties","metadata.date":{"$gte":"${PARTY_START_RANGE}"},"metadata.show_in_main_page":true}`;
  return fetch(encodeURI(request)).then((response) => response.json());
}

function getParties() {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${PARTY_LIMIT}&sort=metadata.date&props=title,slug,content,${metadataFieldsPartiesIndex}&query={
              "type":"san-jose-cabo-party",
              "metadata.show_in_main_page":true,
              "metadata.date": {"$gte": "${PARTY_START_RANGE}"}
       }`
    )
  ).then((response) => response.json());
}

function getMiniParty(slug) {
  let artistProps = [
    'metadata.artists.slug',
    'metadata.artists.title',
    'metadata.artists.metadata.main_image.imgix_url',
    'metadata.artists.metadata.short',
  ].join(',');
  let layoutProps = [
    'metadata.event_layout.slug',
    'metadata.event_layout.title',
    'metadata.event_layout.metadata.content',
    'metadata.event_layout.metadata.main_image.imgix_url',
    'metadata.event_layout.metadata.media_folder',
    'metadata.event_layout.metadata.sections',
    'metadata.event_layout.metadata.valid_for',
    'metadata.event_layout.metadata.notes',
    'metadata.event_layout.metadata.primary_color',
    'metadata.event_layout.metadata.secondary_color',
    'metadata.event_layout.metadata.reservations_link',
  ].join(',');
  let request = `${COSMIC_BASE_URL}&limit=1&sort=metadata.date&props=title,slug,content,metadata.image_url,metadata.main_image,metadata.date,metadata.start_time,metadata.primary_color,metadata.secondary_color,metadata.recurrent,metadata.link,metadata.content,metadata.lineup,${artistProps},${layoutProps}&query={
      "type": "miniparties",
      "slug": "${slug}" }`;
  return fetch(encodeURI(request)).then((response) => response.json());
}

function getClubParties(club) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${PARTY_LIMIT}&sort=metadata.date&props=title,slug,content,${metadataFieldsParties}&query={
      "type":"san-jose-cabo-party",
      "slug": { "$regex": "${club}", "$options": "i"},
      "metadata.date": {"$gte": "${PARTY_START_RANGE}"}
       }`
    )
  ).then((response) => response.json());
}

function getDjSchedule() {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&sort=metadata.start_time&limit=${DJ_SCHEDULE}&props=title,slug,content,metadata.event_link,metadata.event_name,metadata.artist_link,metadata.date,metadata.start_time,metadata.caption,metadata.image_url&query={
            "metadata.date": {"$gte": "${SCHEDULE_START_RANGE}"},
      "type":"${AUTODJSCHDULES}"}`
    )
  ).then((response) => response.json());
}

function getCalendarParties(pagination) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${ALL_PARTY_LIMIT}&sort=metadata.date&props=title,slug,content,${metadataFieldsAllParty}&query={
      "type":"san-jose-cabo-party",
       "metadata.hide_from_calendar":false,
      "metadata.date": {"$gte": "${PARTY_START_RANGE}"}
      }`
    )
  ).then((response) => response.json());
}

function getBeachClubs(pagination) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${pagination.limit}&skip=${pagination.start}&props=title,slug,content,metadata&query={"type":"beachclubs"}`
    )
  ).then((response) => response.json());
}
function getVenues(pagination) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${pagination.limit}&skip=${pagination.start}&props=title,slug,content,metadata&query={"type":"clubs"}`
    )
  ).then((response) => response.json());
}

function getVenue(slug) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${LIMIT}&props=title,slug,metadata&query={"type":"clubs", "slug":"${slug}"}`
    )
  ).then((response) => response.json());
}

function getArtists(pagination) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${pagination.limit}&skip=${pagination.start}&props=title,slug&query={"type":"artists"}`
    )
  ).then((response) => response.json());
}

function getArtistVideo(slug) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=1&props=title,slug,metadata.videoid,metadata.videocaption,metadata.videotitle&query={"type":"artists","slug":"${slug}"}`
    )
  ).then((response) => response.json());
}

function getArtist(slug) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&depth=1&props=title,slug,${metadataFieldsArtist}&query={"type":"artists","slug":"${slug}" }`
    )
  ).then((response) => response.json());
}

function getArticles(pagination) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${pagination.limit}&skip=${pagination.start}&props=title,slug,content,created_at,published_at,metadata.media,metadata.caption,metadata.summary&query={"type":"articles"}`
    )
  ).then((response) => response.json());
}

function getArticle(slug) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&props=title,slug,metadata.content,metadata.media,metadata.caption,published_at,updated_at,created_by,created_at,modified_at,metadata.summary&query={"type":"articles",  "slug":"${slug}"}`
    )
  ).then((response) => response.json());
}

function getFaqs() {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${FAQ_LIMIT}&props=title,slug,content,metadata&query={"type":"faqs"}`
    )
  ).then((response) => response.json());
}

function getFaqsByCategory(category) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=${FAQ_CLUB_LIMIT}&props=title,slug,content,metadata&query={"type":"faqs", "metadata.category": "${category}"}`
    )
  ).then((response) => response.json());
}

function getDynamicContent(slug = 'home-dynamic-content') {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=1&props=title,slug,content,metadata&query={"type":"dynamic-contents", "slug":"${slug}"}`
    )
  ).then((response) => response.json());
}

const getLinks = (slug) => {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&depth=1&props=id,slug,title,metadata&query={"type":"links","slug": { "$regex": "${slug}"}}`
    )
  ).then((response) => response.json());
};

const getFestival = (slug) => {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&props=id,slug,title,content,${metadataFieldsFestival}&query={"type":"festivals", "slug":"${slug}"}`
    )
  ).then((response) => response.json());
};

function getPageConfig(slug) {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=1&props=id,title,slug,metadata.primary_color,metadata.secondary_color,metadata.slug,metadata.smart_links,metadata.generic_links,metadata.carousels&query={"type":"page-configs","slug":"${slug}"}`
    )
  ).then((response) => response.json());
}

const getAIQA = (slug) => {
  return fetch(
    encodeURI(
      `${COSMIC_BASE_URL}&limit=5&depth=1&props=id,slug,title,metadata.answer,metadata.question,metadata.slug,metadata.json&query={"type":"ai-qas","metadata.slug": { "$regex": "^${slug}"}}`
    )
  ).then((response) => response.json());
};

export default {
  getParty,
  getParties,
  getPromotedMiniParties,
  getMiniParties,
  getClubParties,
  getArtistVideo,
  getDjSchedule,
  getVenues,
  getBeachClubs,
  getVenue,
  getArtists,
  getArtist,
  getFaqs,
  getArticle,
  getArticles,
  getFaqsByCategory,
  getFestival,
  getDynamicContent,
  getLinks,
  getCalendarParties,
  getMiniParty,
  getPageConfig,
  getAIQA,
  PARTY_LIMIT,
};
